module.exports = __webpack_public_path__ + "img/flag_197.09749f85.png";